import React from 'react';
import { FormattedMessage } from 'react-intl';

// constants
import { RECIPIENT_FILTER_FIELD_NAMES } from '../../../../../../constraints';

// Components
import { ControlledTextField } from '../../../../../../components/ControlledTextField';
import { FieldLabel } from '../../../../../../components/Form';

const TextFirstNameField = ({
  name = RECIPIENT_FILTER_FIELD_NAMES.FIRST_NAME,
}) => {
  return (
    <>
      <FieldLabel>
        <FormattedMessage id="First name" defaultMessage="First name" />
      </FieldLabel>
      <ControlledTextField name={name} />
    </>
  );
};

export default TextFirstNameField;
